import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import {OCAPaymentFrequencies as PaymentFrequencies} from "@devsontap/tce-api/core/models/enums";

import './index.css';

const PaymentFrequencySelect = ({value, onChange, error, disabled}) => {
    return(
        <FormControl fullWidth error={error}>
            <InputLabel id="paymentFrequencyLabel">Payment Frequency</InputLabel>
            <Select
                name="paymentFrequency"
                value={value}
                labelId="paymentFrequencyLabel"
                onChange={onChange}
                disabled={disabled}>
                <MenuItem value="">Choose One</MenuItem>
                {PaymentFrequencies.map((method) => (
                    <MenuItem value={method.value} key={`paymentFrequency-${method.value}`}>
                        {method.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
};

export default PaymentFrequencySelect;